/**
 * 初診予約タブ切替（遅延iframe読み込み）+ SP横スクロール（SimpleBar）
 */
import SimpleBar from 'simplebar';
import 'simplebar/dist/simplebar.css';

(function () {
  function activateTab(wrap, tab) {
    if (!wrap || !tab) return;

    var tabs = wrap.querySelectorAll('.tab-item');
    var panels = wrap.querySelectorAll('.tab-panel');
    var panelId = tab.getAttribute('data-panel');
    var target = panelId ? document.getElementById(panelId) : null;

    tabs.forEach(function (item) {
      var active = item === tab;
      item.classList.toggle('is-active', active);
      item.setAttribute('aria-selected', active ? 'true' : 'false');
      item.setAttribute('tabindex', active ? '0' : '-1');
    });

    panels.forEach(function (panel) {
      var active = panel === target;
      panel.classList.toggle('is-active', active);
      if (active) {
        panel.removeAttribute('hidden');
      } else {
        panel.setAttribute('hidden', '');
      }
    });

    if (target) {
      var iframe = target.querySelector('iframe');
      if (iframe && !iframe.getAttribute('src')) {
        var src = iframe.getAttribute('data-src');
        if (src) {
          iframe.setAttribute('src', src);
          iframe.removeAttribute('data-src');
        }
      }
    }
  }

  function initTabScrollbars() {
    document.querySelectorAll('.js-reserve-tabs .tab-list-wrap').forEach(function (wrap) {
      if (SimpleBar.instances.get(wrap)) return;
      new SimpleBar(wrap, {
        autoHide: false,
        forceVisible: 'x',
      });
    });
  }

  function initReserveTabs() {
    document.querySelectorAll('.js-reserve-tabs').forEach(function (wrap) {
      var tabs = wrap.querySelectorAll('.tab-item');
      tabs.forEach(function (tab) {
        tab.addEventListener('click', function () {
          activateTab(wrap, tab);
        });
        tab.addEventListener('keydown', function (event) {
          var key = event.key;
          if (key !== 'ArrowRight' && key !== 'ArrowLeft' && key !== 'Home' && key !== 'End') {
            return;
          }
          event.preventDefault();
          var list = Array.prototype.slice.call(tabs);
          var index = list.indexOf(tab);
          var nextIndex = index;
          if (key === 'ArrowRight') nextIndex = (index + 1) % list.length;
          if (key === 'ArrowLeft') nextIndex = (index - 1 + list.length) % list.length;
          if (key === 'Home') nextIndex = 0;
          if (key === 'End') nextIndex = list.length - 1;
          var next = list[nextIndex];
          activateTab(wrap, next);
          next.focus();
        });
      });
    });

    initTabScrollbars();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initReserveTabs);
  } else {
    initReserveTabs();
  }
})();
